/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { RestoreAccountAttributesInput } from '../models/RestoreAccountAttributesInput';

export class ConnectRestoreAccountRequest {
  /**
  * Account display name in Eon.
  */
  'name'?: string;
  'restoreAccountAttributes': RestoreAccountAttributesInput;
  /**
  * Whether this is an internal account used by Eon for testing purposes
  */
  'isInternalAccount'?: boolean;
  'tags'?: { [key: string]: string; };

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "restoreAccountAttributes",
      "baseName": "restoreAccountAttributes",
      "type": "RestoreAccountAttributesInput",
      "format": ""
    },
    {
      "name": "isInternalAccount",
      "baseName": "isInternalAccount",
      "type": "boolean",
      "format": ""
    },
    {
      "name": "tags",
      "baseName": "tags",
      "type": "{ [key: string]: string; }",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ConnectRestoreAccountRequest.attributeTypeMap;
  }

  public constructor() {
  }
}

